module.exports = __webpack_public_path__ + "img/homepage.05939b99.png";